import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";

const usePesquisaGruposObrigatorios = ({ trilhas, gruposMateriais }) => {
  const [pesquisaGruposObrigatorios, setPesquisaGruposObrigatorios] = useState([]);

  useEffect(() => {
    const fetchPesquisaGruposObrigatorios = async () => {
      const gruposObrigatorios = [];
      await db.pesquisaGruposObrigatorios.each((grupo) => {
        gruposObrigatorios.push(grupo);
      });
      setPesquisaGruposObrigatorios(gruposObrigatorios);
    };

    fetchPesquisaGruposObrigatorios();
  }, []);

  const pesquisaGruposObrigatoriosObj = useMemo(() => {
    if (!trilhas?.length || !gruposMateriais?.length || !pesquisaGruposObrigatorios?.length) return [];

    const objMateriais = Object.fromEntries(gruposMateriais.map((cur) => [`id-${cur.id}`, cur]));
    const objTrilhas = Object.fromEntries(trilhas.map((cur) => [`id-${cur.id}`, cur]));

    const obj = {};

    pesquisaGruposObrigatorios.forEach((cur) => {
      const trilha = objTrilhas[`id-${cur.trilhaId}`];

      if (trilha && !obj[trilha.nome]) {
        obj[trilha.nome] = {
          gruposObrigatorios: {},
          gruposObrigatoriosIds: [],
          gruposObrigatoriosNomes: [],
        };
      }

      const grupo = objMateriais[`id-${cur.pesquisaGrupoMaterialId}`];
      if (grupo) {
        obj[trilha.nome].gruposObrigatorios[`id-${grupo.id}`] = grupo;
        obj[trilha.nome].gruposObrigatoriosIds.push(grupo.id);
        obj[trilha.nome].gruposObrigatoriosNomes.push(grupo.nome);
      }
    });

    return obj;
  }, [trilhas, gruposMateriais, pesquisaGruposObrigatorios]);

  return {
    pesquisaGruposObrigatoriosObj,
    pesquisaGruposObrigatorios,
  };
};

export default usePesquisaGruposObrigatorios;
